import React from 'react';
import AlbumsContainer from './AlbumsContainer';

class AlbumsScreen extends React.Component {

    public render() {
        return <AlbumsContainer />
    }

}

export default AlbumsScreen;